/**
 * Local development environments
 */
export const environment = {
  url: 'https://dyn-amaiadev-dq.amlab7.com/aero/llm/srv-amaia',
  profile: 'AM_AV_Dev',
  production: false,
  domain: 'lobbycloudgate.amx-digital.com',
  clientId: 'HKlvQJAmxkH2B9b4c8qwqqLb92NNAa0Q',
  documentTtlSeconds: 3600,
  logsUrl:
    'https://dyn-amaiadev-dq.amlab7.com/aero/llm/srv-amaia/logs/ui-event',
  notesUrl: 'https://dyn-amaiadev-dq.amlab7.com/aero/llm/srv-amaia',
  allowedFrameSrc:
    'https://*.s3.amazonaws.com https://*.s3.us-east-1.amazonaws.com https://dyn-amaiadev-dq.amlab7.com',
  bypassAuth: false,
  // Combo "Tipo de empleado" para agentes especializados RRHH/LINC.
  // Pendiente de validación del SME: desactivado en todos los entornos.
  rrhhEmployeeProfileCombo: false
};
